export enum ProjectChecklistItemType {
  Folder,
  File
}
